import { useState, useEffect } from 'react';

/**
 * Hook that ensures a loading state is shown for a minimum duration
 * @param {boolean} isLoading - The actual loading state from a mutation or query
 * @param {number} [minimumTime=300] - Minimum time in milliseconds to show loading state
 * @returns {boolean} - Whether to show the loading indicator
 */
export const useMinimumLoadingTime = (isLoading, minimumTime = 300) => {
  const [showLoading, setShowLoading] = useState(false);
  const [loadingStartTime, setLoadingStartTime] = useState(0);

  useEffect(() => {
    if (isLoading && !showLoading) {
      setShowLoading(true);
      setLoadingStartTime(Date.now());
    } else if (!isLoading && showLoading && loadingStartTime > 0) {
      const elapsed = Date.now() - loadingStartTime;
      const remainingTime = Math.max(0, minimumTime - elapsed);

      setTimeout(() => {
        setShowLoading(false);
        setLoadingStartTime(0);
      }, remainingTime);
    }
  }, [isLoading, showLoading, loadingStartTime, minimumTime]);

  return showLoading;
};
